import './SunBeams.css';
import { ATMOSPHERE_SUN_BEAMS_URL } from '../atmosphereAssets';

type SunBeamsProps = {
  className?: string;
};

/** From Figma Group 1321317390 (118:26) — sun beams + particles. */
export function SunBeams({ className }: SunBeamsProps) {
  return (
    <img
      className={['new-delivery-sun-beams', className].filter(Boolean).join(' ')}
      src={ATMOSPHERE_SUN_BEAMS_URL}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
